import axios from 'axios';
import store from '@/store'
import router from "@/router";
import {MessageBox, Message} from "element-ui";
import {debounce, throttle} from "@/services/common";
import { Log500Error, LogRequestInfo, LogTimeoutError } from './cartxLog';

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // 如跨域请求时要带上cookies,则设置为true
  timeout: 120000, // 请求超时时长
});

service.interceptors.request.use(
  (config: any) => {
    // 在发送请求之前做些什么
    config.cartxTime = performance?.now() || Date.now();
    return config;
  },
  (error: any) => {
    console.log(error);
    store.commit('SET_LOADING', false);
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  (response) => {
    const config:any = response?.config;
    if (config?.cartxTime) {
      const t = performance?.now() || Date.now();
      const duration = t - config?.cartxTime;
      // console.log('reqeust duration', t - response?.config?.cartxTime);
      LogRequestInfo({
        ru:response.config?.url||(response.request?.custom?.url||''), // request url
        rp:response.config?.data||(response.request?.custom?.options?.body||''), // request params
        ru1:response.request?.responseURL||'', // response url
        m:response.config?.method||'POST', // method
        em:response.status||'', // error message
        er:{code:response?.data?.code,message:response?.data?.message}||'', // error response
        time: duration,
        cost: response?.data?.cost || '',
      });
    }
    store.commit('SET_LOADING', false);
    if(response.data && response.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      if(router.currentRoute.path !== '/login') {
        logFail();
      }
      return Promise.reject(new Error('Error'));
    }
    if (!response.data || response.data.code !== 0) {
      Message.error({
        message: (response && response.data && response.data.message) || '网络请求失败，请稍后重试',
        center: true
      })
      return Promise.reject(new Error(response && response.data && response.data.message|| 'Error'));
    }
    return response;
  },
  (error) => {
    if (error?.config?.cartxTime) {
      const t = performance?.now() || Date.now();
      const duration = t - error?.config?.cartxTime;
      // console.log('reqeust duration', t - response?.config?.cartxTime);
      LogRequestInfo({
        ru:error.config?.url||(error.request?.custom?.url||''), // request url
        rp:error.config?.data||(error.request?.custom?.options?.body||''), // request params
        ru1:error.request?.responseURL||'', // response url
        m:error.config?.method||'POST', // method
        em:error.message||(error.status||error.status?.status), // error message
        er:error.response?.data||'', // error response
        time: duration,
        cost: error?.response?.data?.cost || '',
      });
    }
    store.commit('SET_LOADING', false);
    if(error.response) {
      if(error.response.data.code === 401) {
        // 如果返回401 即没有权限，跳到登录页重新登录
        if(router.currentRoute.path !== '/login') {
          logFail();
        }
        return Promise.reject(error);
      }
    }

    if (error.request && error.request.readyState == 4 && error.request.status >= 500) {
      // 500 以上的服务器请求，触发埋点上报:
      Log500Error({
        ru:error.config?.url||(error.request?.custom?.url||''), // request url
        rp:error.config?.data||(error.request?.custom?.options?.body||''), // request params
        ru1:error.request?.responseURL||'', // response url
        m:error.config?.method||'POST', // method
        em:error.message||(error.status||'500+'), // error message
        er:error.response?.data||'', // error response
        cost: error?.response?.data?.cost || '',
      });
    }


    if (error?.message?.includes('timeout')) {
      // 报个超时状态出去
      LogTimeoutError({
        ru:error.config?.url||(error.request?.custom?.url||''), // request url
        rp:error.config?.data||(error.request?.custom?.options?.body||''), // request params
        ru1:error.request?.responseURL||'', // response url
        m:error.config?.method||'POST', // method
        em:error?.message||(error?.status||error.request?.status||'504'), // error message
        er:error.response?.data||'', // error response
        cost: error?.response?.data?.cost || '',
      });
    }
    Message.error({
      message: (error.response && error.response.data && error.response.data.message) || '网络请求失败，请稍后重试',
      center: true
    })
    return Promise.reject(error);

  },
);

const logFail = debounce(() => {
  if (process.env.NODE_ENV === 'production') {
    localStorage.setItem('token','');
    window.location.href = '/cartsee-new/login?redirect='+ encodeURIComponent(router.currentRoute.fullPath)
  }
}, 1000)

export default service;
